<app-symbol-icons></app-symbol-icons>
<app-symbol-avatars></app-symbol-avatars>
